const targetNode = document.querySelector('header')

const observerOptions = {
    childList: true,
    subtree: true
}

// Variables to store the focusable elements
let firstFocusableElement = null
let lastFocusableElement = null

// Keydown handler for focus trapping (stays the same, but elements change)
function handleKeydown (e) {
    if (e.target === firstFocusableElement && e.key === 'Tab' && e.shiftKey) {
        e.preventDefault()
        lastFocusableElement.focus()
    } else if (e.target === lastFocusableElement && e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault()
        firstFocusableElement.focus()
    }
}

// Handle focus trapping
function setupFocusTrapping () {
    const rebuySearch = document.querySelector('.rebuy-quick-view-dropdown')

    if (!rebuySearch) return

    // Remove existing keydown event listener to avoid duplication
    if (firstFocusableElement && lastFocusableElement) {
        rebuySearch.removeEventListener('keydown', handleKeydown)
    }

    const focusableElements = rebuySearch.querySelectorAll('a[href], button, input')

    firstFocusableElement = focusableElements[0]
    lastFocusableElement = focusableElements[focusableElements.length - 1]

    // Add new keydown event listener for focus trapping
    rebuySearch.addEventListener('keydown', handleKeydown)
}

// Mutation observer callback
const observerCallback = function (mutationsList) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    // When rebuy is added to the page
                    if (node.id === 'rebuy-quick-view-dropdown-search') {
                        setupFocusTrapping()
                    }

                    // When rebuy results are added to the DOM
                    if (node.classList.contains('rebuy-quick-view__product')) {
                        setupFocusTrapping()
                    }
                }
            })

            mutation.removedNodes.forEach(removedNode => {
                if (removedNode.nodeType === 1) {
                    // When rebuy results are removed from the DOM
                    if (removedNode.id === 'rebuy-quick-view-overlay') {
                        setupFocusTrapping()
                    }
                }
            })
        }
    }
}

// Create the MutationObserver with the callback
const observer = new MutationObserver(observerCallback)

// Start observing for changes
observer.observe(targetNode, observerOptions)
